"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormHpv = FormHpv;
var react_1 = __importStar(require("react"));
var row_ctx_1 = require("../contexts/row_ctx");
var api_1 = require("../api");
var modal_1 = require("../modal");
function FormHpv() {
    var closeModal = (0, modal_1.useModalClose)();
    var _a = (0, react_1.useContext)(row_ctx_1.RowContext), localRecord = _a.localRecord, updateRecord = _a.updateRecord;
    var results = localRecord.results;
    var handleResultChange = function (index, value) {
        results[index].result = value;
        results[index].positive = value.includes("阳性");
        updateRecord({ results: results });
    };
    var resetResult = function (event) {
        event.preventDefault();
        var updatedResults = results.map(function (result) { return (__assign(__assign({}, result), { positive: null, result: "" })); });
        updateRecord({ results: updatedResults });
    };
    var setPositiveResult = function (event) {
        event.preventDefault();
        var updatedResults = results.map(function (result) { return (__assign(__assign({}, result), { positive: true, result: "阳性（+）" })); });
        updateRecord({ results: updatedResults });
    };
    var setNegativeResult = function (event) {
        event.preventDefault();
        var updatedResults = results.map(function (result) { return (__assign(__assign({}, result), { positive: false, result: "阴性（-）" })); });
        updateRecord({ results: updatedResults });
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        (0, api_1.modifyResults)(localRecord.order_id, results)
            .then(function (updatedData) { return updateRecord(updatedData); })
            .catch(console.error);
        closeModal();
    };
    return (react_1.default.createElement("div", { className: "form-container" },
        react_1.default.createElement("form", { className: "zmsk-form hpv-form", onSubmit: handleSubmit },
            react_1.default.createElement("button", { onClick: resetResult }, "\u4E00\u952E\u91CD\u7F6E"),
            react_1.default.createElement("button", { onClick: setNegativeResult }, "\u4E00\u952E\u9634\u6027"),
            react_1.default.createElement("button", { onClick: setPositiveResult }, "\u4E00\u952E\u9633\u6027"),
            react_1.default.createElement("div", { className: "results-grid" }, results.map(function (result, index) { return (react_1.default.createElement("div", { key: index, className: "result-row" },
                react_1.default.createElement("div", { className: "form-group" },
                    react_1.default.createElement("label", null, "\u98CE\u9669\u7B49\u7EA7"),
                    react_1.default.createElement("input", { name: "risk", value: result.risk === "high"
                            ? "高风险"
                            : "低风险", readOnly: true })),
                react_1.default.createElement("div", { className: "form-group" },
                    react_1.default.createElement("label", null, "\u4E9A\u578B"),
                    react_1.default.createElement("input", { name: "subtype", value: result.subtype, readOnly: true })),
                react_1.default.createElement("div", { className: "form-group" },
                    react_1.default.createElement("label", null, "\u68C0\u6D4B\u7ED3\u679C"),
                    react_1.default.createElement("select", { name: "result", value: result.result, onChange: function (e) {
                            return handleResultChange(index, e.target.value);
                        } },
                        react_1.default.createElement("option", { value: "" }),
                        react_1.default.createElement("option", { value: "\u9634\u6027\uFF08-\uFF09" }, "\u9634\u6027\uFF08-\uFF09"),
                        react_1.default.createElement("option", { value: "\u9633\u6027\uFF08+\uFF09" }, "\u9633\u6027\uFF08+\uFF09"))),
                react_1.default.createElement("div", { className: "form-group" },
                    react_1.default.createElement("label", null, "\u53C2\u8003\u533A\u95F4"),
                    react_1.default.createElement("input", { name: "reference", value: result.reference, readOnly: true })))); })),
            react_1.default.createElement("div", { className: "foot-button-group" },
                react_1.default.createElement("button", { type: "button", className: "zmsk-button", onClick: closeModal }, "\u53D6\u6D88"),
                react_1.default.createElement("button", { type: "submit", className: "zmsk-button" }, "\u63D0\u4EA4")))));
}
